import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Alignments from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import { MediaSection, SectionInner, } from '@polestar/component-warehouse-react/components/section/Section';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import Grids from '@polestar/component-warehouse-react/tokens/grids/Grids';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
const HeroSectionLegacy = forwardRef(({ mobilePosition, children, ...props }, ref) => {
    return (React.createElement(StyledSection, { ...props, ref: ref },
        React.createElement(StyledMedia, { mobilePosition: mobilePosition }, props.background),
        React.createElement(ContentWrapper, { mobilePosition: mobilePosition },
            React.createElement(SectionInner, null,
                React.createElement(ContentInner, null, children)))));
});
HeroSectionLegacy.displayName = 'HeroSectionLegacy';
export default HeroSectionLegacy;
const StyledSection = styled(MediaSection) `
  position: relative;
  flex-direction: column;
  display: flex;
  align-items: flex-start;
`;
const ContentWrapper = styled.div(({ mobilePosition }) => css(css `
      ${responsiveStyles({
    insetInlineStart: {
        mobile: Grids.mobile.gutter,
        tablet: Grids.tablet.gutter,
        desktop: Grids.desktop.gutter,
    },
    insetInlineEnd: {
        mobile: Grids.mobile.gutter,
        tablet: Grids.tablet.gutter,
        desktop: Grids.desktop.gutter,
    },
})}
    `, !!mobilePosition &&
    css `
        ${MediaQueries.tablet} {
          position: absolute;
        }
      `, !mobilePosition &&
    css `
        position: absolute;
      `));
const ContentInner = styled.div(({ theme }) => css `
    ${responsiveStyles({
    margin: theme.heroSectionLegacy.margin,
})}
  `);
const StyledMedia = styled.div(({ theme, mobilePosition }) => css(css `
      background-color: ${theme.heroSectionLegacy.backgroundColor};
      display: flex;
      width: 100%;
    `, responsiveStyles({
    order: {
        mobile: mobilePosition === Alignments.top ? 1 : 0,
        tablet: 0,
    },
})));
